import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { helper } from 'src/environments/helper';
import { ZileLibereService } from '../zile-libere.service';
import { NotificationService } from 'src/app/services/notification.service';
import { AuthService } from 'src/app/services/auth.service';
import { finalize } from 'rxjs';
import { formatDate } from '@angular/common';

@Component({
    selector: 'app-edit-zile',
    templateUrl: './edit-zile.component.html',
    styleUrls: ['./edit-zile.component.scss'],
})
export class EditZileComponent {
    // general error
    errorTitle: string = environment.config.customNotifications.headers.error;
    errorIcon: string = environment.config.customNotifications.icons.error;
    errorType: string = environment.config.customNotifications.icons.error;
    helper = helper;

    token!: string;
    isLoading = false;
    formattedDate!: string;

    today = new Date();

    form: FormGroup = new FormGroup({
        off_day_name: new FormControl(this.data.off_day_name, Validators.required),
        date: new FormControl(this.data.date, Validators.required),
    });
    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: any,
        private dialogRef: MatDialogRef<EditZileComponent>,
        private zileLibereService: ZileLibereService,
        private notificationService: NotificationService,
        private authService: AuthService
    ) {
        this.processToken();
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    processToken() {
        const tokenObj = this.authService.returnTokenUser();
        tokenObj.then((token) => {
            this.token = token;
            this.zileLibereService.setToken(token);
        });
    }

    onDateChange(event: any) {
        this.formattedDate = formatDate(event.value, 'yyyy-MM-dd', 'en-US');
        console.log(this.formattedDate);
    }

    submitForm() {
        this.isLoading = true;

        const updatedZileLibere = {
            off_day_name: this.form.get('off_day_name')?.value,
            date: this.form.get('date')?.value,
            id: this.data.id,
        };

        this.zileLibereService
            .updateZileLibere(updatedZileLibere)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: () => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
